<script setup>
import { ref, onMounted } from "vue";
import { useFilteredFeedStore } from "../stores/FilteredFeed.js";

const store = useFilteredFeedStore();
const { endpoint } = store;

const props = defineProps({
	label: {
		type: String,
		required: false,
		default: "Load more",
	},
});
</script>
<template>
	<footer class="mt-12">
		<div class="xl:container mx-auto flex justify-center gap-8">
			<a @click.prevent="store.loadMore()" href="#" class="button"> <span v-html="props.label"></span></a>
		</div>
	</footer>
</template>
